import type { SpecifyRow } from "./core";
import type { SpecifyFieldDefinition } from "./types";

export const rowSpecifyFields = <Event>(
  rows: readonly SpecifyRow[],
  labels: Readonly<Record<string, string>>,
  confirm: (rowId: string, value: string) => Event,
): readonly SpecifyFieldDefinition<Event>[] =>
  rows.flatMap((row) =>
    row.customPrompt === undefined
      ? []
      : [
          {
            target: { kind: "row-label" as const, rowId: row.id },
            prompt: row.customPrompt,
            value: labels[row.id] ?? "",
            selected: true,
            confirm: (value: string) => confirm(row.id, value),
          },
        ],
  );
